import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import DeleteModal from "components/Common/DeleteModal"
import { usePagination } from "hooks/usePagination"
import ResultHandler from "components/ResultHandler"
import PaginationHandler from "components/PaginationHandler"
import { deletePresenter, getPresenters } from "api/presenters"
import TableHeaderHandler from "components/TableHeaderHandler"
import { PERMISSIONS } from "api/permissions"
import { useTranslation } from "react-i18next"
import { useResponse } from "hooks/useResponse"
import TableAction from "components/TableAction"
import EmptyData from "components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import CustomImage from "components/CustomImage"

export default function PresentersTable() {
  const { t } = useTranslation()
  const navigate = useHistory()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
  } = usePagination(getPresenters)

  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingPresenter, setDeletingPresenter] = useState(null)

  const { setData } = useResponse(deletePresenter, () => {
    setShow(false)
    setDeletingPresenter(null)
    setPayload({})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingPresenter })
  }

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.PRESENTER_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-presenter"
      />
      <div className="table-rep-plugin">

        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th style={{ width: "20%" }}>{t("forms.Image")}</Th>
                <Th style={{ width: "50%" }}>{t("forms.Name")}</Th>
                <Th style={{ width: "30%" }}>
                  {t("tables.Action")}
                </Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.presenters.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>
                        <CustomImage src={row.image_url} width="40px" height="40px" />
                      </Td>
                      <Td>
                        <Link to={"/view-presenter/" + row.id}>{row.name}</Link>
                      </Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          hasVersions={false}
                          editPermission={PERMISSIONS.PRESENTER_EDIT}
                          deletePermission={PERMISSIONS.PRESENTER_DELETE}
                          type="presenter"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingPresenter}
                        />
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.presenters.length === 0}
              msg="No Presenters Found."
            />
          )}

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}
          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  )
}
